<template>
  <div id="page-terms-of-use" class="w-full px-5 pb-5 bg-white md:pt-4">
    <h1 class="text-3xl py-6">{{ $t('static.terms_of_use.title') }}</h1>
    <div class="content text-article">
      <div v-html="$t('static.terms_of_use.content')"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'static',
})
</script>
